import Config from "config"; // 프로그램 환경설정 모듈

function trimNull(a) {
  if (!a) {
    return a;
  }

  if (!a.indexOf) {
    return a;
  }

  var c = a.indexOf("\0");
  if (c > -1) {
    return a.substr(0, c);
  }
  return a;
}

class NSDicomReadModelAdapter {
  elements = {};
  byteArray = null;

  constructor(elements, byteArray) {
    this.elements = elements;
    this.byteArray = byteArray;
  }
  getElement(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0x" + tag.slice(1).toUpperCase();
    }

    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return this.elements[renameTag];
  }
  string(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0x" + tag.slice(1).toUpperCase();
    }

    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return trimNull(this.elements[renameTag].value).trim();
  }
  int16(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseInt(trimNull(this.elements[renameTag].value));
  }
  uint16(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseInt(trimNull(this.elements[renameTag].value));
  }
  int32(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseInt(trimNull(this.elements[renameTag].value));
  }
  uint32(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseInt(trimNull(this.elements[renameTag].value));
  }
  intString(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseInt(trimNull(this.elements[renameTag].value));
  }
  double(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseFloat(trimNull(this.elements[renameTag].value));
  }
  float(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseFloat(trimNull(this.elements[renameTag].value));
  }
  floatString(tag) {
    let renameTag = tag;
    if (tag[0] === "x") {
      renameTag = "0" + tag;
    }
    let element = this.elements[renameTag];

    if (!element || element.length === 0) {
      return undefined;
    }
    return parseFloat(trimNull(this.elements[renameTag].value));
  }
}

class NSDicomLoaderAdapter {
  _dicomLoader = null;

  parseDicom(byteArray) {
    const dicomLib = Config.lib.dicomLoader.entry;
    this._dicomLoader = new dicomLib();
    this._dicomLoader.readFile(byteArray);
    let elements = this._dicomLoader.DicomDataList.element;
    const byteBuffer = new Uint8Array(this._dicomLoader.byteBuffer);

    // pixel data element 추가
    elements["0x7FE00010"] = {};
    elements["0x7FE00010"] = this._dicomLoader.pixelData;
    elements["0x7FE00010"].dataOffset = this._dicomLoader.pixelData.byteOffset;
    return new NSDicomReadModelAdapter(elements, byteBuffer);
  }
}

//export default NSDicomLoaderAdapter;
export default new NSDicomLoaderAdapter();
